// La version du jeu, affichée dans l'en-tête. À faire avancer en même temps que package.json,
// et à jalonner dans doc/journal-de-bord.md.
export const GAME_VERSION = 'v0.5';
